import React from 'react';
import * as dates from '@simplybenefits/sb-dates';
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';
import * as localizationMaps from '../../localization/maps.js';
import Text from '../../components/Text.js';
import TextInput from '../../components/TextFields/TextInput.js';
import DateInput from '../../components/TextFields/DateInput.js';
import Checkbox from '../../components/Checkbox.js';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

/**
 * 
 * @param {*} data 
 * @returns 
 */
const renderDependentDetails = data => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
  bold: true,
  medium: true,
  customStyle: {
    marginTop: '25px'
  }
}, i18n.t(tokens.labels.changeRequests.dependentDetails)), /*#__PURE__*/React.createElement(Grid, {
  container: true,
  direction: "row",
  columnSpacing: 2
}, /*#__PURE__*/React.createElement(Grid, {
  item: true,
  xs: 6
}, /*#__PURE__*/React.createElement(TextInput, {
  label: i18n.t(tokens.labels.firstname),
  value: data?.dependentDetails?.firstname,
  variant: "outlined",
  fullWidth: true,
  disabled: true
})), /*#__PURE__*/React.createElement(Grid, {
  item: true,
  xs: 6
}, /*#__PURE__*/React.createElement(TextInput, {
  label: i18n.t(tokens.labels.lastname),
  value: data?.dependentDetails?.lastname,
  variant: "outlined",
  fullWidth: true,
  disabled: true
}))));

/**
 * 
 * @param data
 * @param errors
 * @param handleChange
 * @param isMaster
 */
function Details({
  data,
  errors,
  handleChange,
  accessData,
  isMaster = false
}) {
  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column'
    },
    sectionHeader: {
      marginTop: '25px'
    }
  };

  /**
   * Always disabled for admin/members, disabled for master users if not in 'Pending', 'Incomplete', or 'Suspended' status or no write access
   */
  const isAgentCanReview = accessData.agentWriteAccess && ['PENDING AGENT REVIEW', 'INCOMPLETE', 'SUSPENDED'].includes(data.status.toUpperCase());
  const isDisabled = !accessData.isAgent || !isAgentCanReview;
  return /*#__PURE__*/React.createElement("div", {
    style: styles.container
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "row",
    columnSpacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    md: 2
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    medium: true
  }, i18n.t(tokens.labels.changeRequests.requesterName)), /*#__PURE__*/React.createElement(Text, {
    medium: true
  }, data.requesterName)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    md: 2
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    medium: true
  }, i18n.t(tokens.labels.changeRequests.requesterType)), /*#__PURE__*/React.createElement(Text, {
    medium: true
  }, localizationMaps.fromEnglish("userType", data.requesterType))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    md: 2
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    medium: true
  }, i18n.t(tokens.labels.changeRequests.identifier)), /*#__PURE__*/React.createElement(Text, {
    medium: true
  }, data.identifier)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    md: 2
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    medium: true
  }, i18n.t(tokens.labels.changeRequests.dateSubmitted)), /*#__PURE__*/React.createElement(Text, {
    medium: true
  }, dates.getStartOfDay(data.submittedDate, 'll', i18n.locale)))), /*#__PURE__*/React.createElement(Text, {
    bold: true,
    medium: true,
    customStyle: styles.sectionHeader
  }, i18n.t(tokens.labels.changeRequests.personalDetails)), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "row",
    columnSpacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: i18n.t(tokens.labels.changeRequests.organizationName),
    value: data.company,
    variant: "outlined",
    fullWidth: true,
    disabled: true
  })), accessData.isAgent && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: i18n.t(tokens.labels.groupNumber),
    value: data.groupNum,
    variant: "outlined",
    fullWidth: true,
    disabled: true
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: i18n.t(tokens.labels.division),
    value: data.division,
    variant: "outlined",
    fullWidth: true,
    disabled: true
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: i18n.t(tokens.labels.certificateNumber),
    value: data.cert,
    variant: "outlined",
    fullWidth: true,
    disabled: true
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: i18n.t(tokens.labels.firstname),
    value: data.firstname,
    variant: "outlined",
    fullWidth: true,
    disabled: true
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: i18n.t(tokens.labels.lastname),
    value: data.lastname,
    variant: "outlined",
    fullWidth: true,
    disabled: true
  }))), data.type === 'Edit Dependent Details' && data?.dependentDetails ? renderDependentDetails(data) : null, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    medium: true,
    customStyle: styles.sectionHeader
  }, i18n.t(tokens.labels.changeRequests.typeOfChangeRequest)), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "row"
  }, /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset",
    disabled: true
  }, /*#__PURE__*/React.createElement(FormGroup, {
    row: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2.4
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: data.type === "Edit Member Details",
      value: "memberDetails",
      color: "secondary"
    }),
    label: /*#__PURE__*/React.createElement(Text, {
      medium: true
    }, i18n.t(tokens.labels.changeRequests.memberDetails))
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2.4
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: data.type === "Edit Employment Details",
      value: "employmentDetails",
      color: "secondary"
    }),
    label: /*#__PURE__*/React.createElement(Text, {
      medium: true
    }, i18n.t(tokens.labels.employees.employmentDetails))
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2.4
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: data.type === "Reinstate Benefits",
      value: "reinstateBenefits",
      color: "secondary"
    }),
    label: /*#__PURE__*/React.createElement(Text, {
      medium: true
    }, i18n.t(tokens.labels.changeRequests.reinstateBenefits))
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2.4
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: data.type === "Waive Benefits",
      value: "waiveBenefits",
      color: "secondary"
    }),
    label: /*#__PURE__*/React.createElement(Text, {
      medium: true
    }, i18n.t(tokens.labels.changeRequests.waiveBenefits))
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2.4
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: data.type === "Add a Dependent",
      value: "addDependent",
      color: "secondary"
    }),
    label: /*#__PURE__*/React.createElement(Text, {
      medium: true
    }, i18n.t(tokens.labels.changeRequests.addDependent))
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2.4
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: data.type === "Edit Dependent Details",
      value: "editDependent",
      color: "secondary"
    }),
    label: /*#__PURE__*/React.createElement(Text, {
      medium: true
    }, i18n.t(tokens.labels.changeRequests.editDependent))
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2.4
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: data.type === "Remove a Dependent",
      value: "removeDependent",
      color: "secondary"
    }),
    label: /*#__PURE__*/React.createElement(Text, {
      medium: true
    }, i18n.t(tokens.labels.changeRequests.removeDependent))
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2.4
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: ["Add Irrevocable Beneficiary", "Add Revocable Beneficiary"].includes(data.type),
      value: "addBeneficiary",
      color: "secondary"
    }),
    label: /*#__PURE__*/React.createElement(Text, {
      medium: true
    }, i18n.t(tokens.labels.changeRequests.addBeneficiary))
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2.4
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: ["Edit Irrevocable Beneficiary", "Edit Revocable Beneficiary"].includes(data.type),
      value: "editBeneficiary",
      color: "secondary"
    }),
    label: /*#__PURE__*/React.createElement(Text, {
      medium: true
    }, i18n.t(tokens.labels.changeRequests.editBeneficiary))
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2.4
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: ["Remove Irrevocable Beneficiary", "Remove Revocable Beneficiary"].includes(data.type),
      value: "removeBeneficiary",
      color: "secondary"
    }),
    label: /*#__PURE__*/React.createElement(Text, {
      medium: true
    }, i18n.t(tokens.labels.changeRequests.removeBeneficiary))
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2.4
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: data.typeOfChange === "Add Trustee",
      value: "addTrustee",
      color: "secondary"
    }),
    label: /*#__PURE__*/React.createElement(Text, {
      medium: true
    }, i18n.t(tokens.labels.changeRequests.addTrustee))
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2.4
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: data.typeOfChange === "Edit Trustee",
      value: "editTrustee",
      color: "secondary"
    }),
    label: /*#__PURE__*/React.createElement(Text, {
      medium: true
    }, i18n.t(tokens.labels.changeRequests.editTrustee))
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2.4
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: data.typeOfChange === "Remove Trustee",
      value: "removeTrustee",
      color: "secondary"
    }),
    label: /*#__PURE__*/React.createElement(Text, {
      medium: true
    }, i18n.t(tokens.labels.changeRequests.removeTrustee))
  }))))), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "row",
    columnSpacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(DateInput, {
    label: i18n.t(tokens.labels.changeRequests.effectiveDate),
    value: data.effectiveDate,
    onChange: event => handleChange('effectiveDate', event.target.value),
    error: errors.effectiveDate,
    variant: "outlined",
    fullWidth: true,
    disabled: isDisabled
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: i18n.t(tokens.labels.changeRequests.reasonForChange),
    value: data.reasonForChange,
    onChange: event => handleChange('reasonForChange', event.target.value),
    error: errors.reasonForChange,
    variant: "outlined",
    fullWidth: true,
    disabled: isDisabled
  }))));
}
export default Details;